var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { SubAPI } from "./SubAPI";
var ServiceRecordsAPI = /** @class */ (function (_super) {
    __extends(ServiceRecordsAPI, _super);
    function ServiceRecordsAPI() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ServiceRecordsAPI.prototype.list = function (props) { return this.fetcher.get("/api/service-records", props); };
    ServiceRecordsAPI.prototype.get = function (id) { return this.fetcher.get("/api/service-record", { id: id }); };
    ServiceRecordsAPI.prototype.create = function (rec) { return this.fetcher.post("/api/service-record/create", rec); };
    ServiceRecordsAPI.prototype.update = function (rec) { return this.fetcher.post("/api/service-record/update", rec); };
    ServiceRecordsAPI.prototype.createCost = function (input) { return this.fetcher.post("/api/service-record/cost/create", input); };
    ServiceRecordsAPI.prototype.updateCost = function (input) { return this.fetcher.post("/api/service-record/cost/update", input); };
    ServiceRecordsAPI.prototype.archiveCosts = function (input) { return this.fetcher.post("/api/service-record/cost/bulk-archive", input); };
    ServiceRecordsAPI.prototype.listCosts = function (props) { return this.fetcher.get("/api/service-record/costs", props); };
    ServiceRecordsAPI.prototype.listOutsourceCompanies = function () { return this.fetcher.get("/api/service-record/outsource-companies"); };
    ServiceRecordsAPI.prototype.listFiles = function (props) { return this.fetcher.get("/api/service-record/files", props); };
    ServiceRecordsAPI.prototype.uploadFile = function (input) { return this.fetcher.postFormData("/api/service-record/file/upload", { info: JSON.stringify(input.info), file: input.file }); };
    ServiceRecordsAPI.prototype.removeFiles = function (props) { return this.fetcher.post("/api/service-record/files/bulk-archive", props); };
    return ServiceRecordsAPI;
}(SubAPI));
export { ServiceRecordsAPI };
